import React, { useState } from 'react'
import Checkbox from '@mui/material/Checkbox';
import { green, red } from '@mui/material/colors';

const CheckBox = (props) => {
    const {selectedTopic, setTopicIsActive, topicIsActive} = props;
    const [checked, setChecked] = useState(topicIsActive);
  
    const handleCheckbox = (event) => {
      if(checked){
        setTopicIsActive(false);
        setChecked(false);
      } 
      else {
        setTopicIsActive(true);
        setChecked(true);
      }
    }
    return (
        <div>
            <p> Topic Access: {selectedTopic}<span>
                <Checkbox 
                    defaultChecked={topicIsActive}
                    onChange={handleCheckbox}
                    size="large"
                    sx={{
                        color: red[600],
                        '&.Mui-checked': {
                        color: green[600],
                        },
                    }} 
                />
            </span></p>
        </div>
    )
}

export default CheckBox;